/*
 * @Author: YuanYuan
 * @Date: 2024-02-05 10:04:47
 * @LastEditTime: 2024-02-05 10:07:29
 * @description: 所有接口集合
 */
const context = require.context('./', true, /^\.\/(?!index).*?\.js$/)

const modules = {}

context.keys().forEach(key => {
  const name = key.replace(/\.\/(.*)?\.js/, (str, $1) => $1)
  modules[name] = context(key).default
})

export default modules
